import { type DealTrackingLimitedPartnerBreakdown } from "@vega-api/generated/types/dealTrackingLimitedPartnerBreakdown";
import { type DealTrackingMetric } from "@vega-api/generated/types/dealTrackingMetric";
import { type DealTrackingSubtotalsByStageItem } from "@vega-api/generated/types/dealTrackingSubtotalsByStageItem";
import { m } from "@vega-core/paraglide/messages";

import { DealTrackingAnalyticsCards } from "../components/DealTrackingMetrics/DealTrackingAnalyticsCards";
import { PieChartMetrics } from "../components/PieChartMetrics/PieChartMetrics";
import {
  SubtotalsByStage,
  subtotalsByStageToStages,
} from "../components/SubtotalsByStage/SubtotalsByStage";
import { TrackAnalyticsTable } from "../components/TrackAnalyticsTable/TrackAnalyticsTable";
import { splitDealTrackingMetrics } from "../utils/metricGuards";

type AnalyticsViewProps = {
  dealId: string;
  metrics: DealTrackingMetric[];
  subtotalsByStage: DealTrackingSubtotalsByStageItem[];
  limitedPartnerBreakdown: DealTrackingLimitedPartnerBreakdown[];
  isLoading: boolean;
};

export const AnalyticsView = ({
  dealId,
  metrics,
  subtotalsByStage,
  limitedPartnerBreakdown,
  isLoading,
}: AnalyticsViewProps) => {
  const { topMetrics, pieChartMetrics } = splitDealTrackingMetrics(metrics);

  return (
    <>
      <DealTrackingAnalyticsCards isLoading={isLoading} metrics={topMetrics} />
      <SubtotalsByStage
        isLoading={isLoading}
        stages={subtotalsByStageToStages(subtotalsByStage)}
      />
      <PieChartMetrics
        centerLabel={m.coInvestments_tracking_totalCount()}
        dataTestId="deal-tracking-pie-charts"
        isLoading={isLoading}
        pieChartMetrics={pieChartMetrics}
      />
      <div className="space-y-4 pb-52">
        <TrackAnalyticsTable
          data={limitedPartnerBreakdown}
          dealId={dealId}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};
